exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".el-dialog__body{padding-top:0}.payment-links-yape .el-button--primary{background-color:#10cbb4!important;border-color:#10cbb4!important}.bg-yape{background:#5e186c}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-240e7fd0","scoped":false,"hasInlineConfig":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./resources/js/views/tenant/documents/partials/dialog_link_payment.vue
// module id = 0PCh
// module chunks = 0